import { useStorage } from './use-storage';

/**
 *
 * @param key - The key to store the value in session storage. If undefined, the value will be stored in the state only.
 * @param initialValue
 * @param shouldDispatchEvents - Whether to dispatch a storage event when the value is changed.
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useSessionStorage = <T>(key: string | undefined, initialValue?: T, shouldDispatchEvents = true) => {
	return useStorage<T>('sessionStorage', key, initialValue, shouldDispatchEvents);
};
